module.exports = __webpack_public_path__ + "img/icon_e1.27d82c90.png";